// Add new route here — consider adding it to lists below
export const ROUTE_NAMES = {
    ROOT: 'root',
    MAIN: 'main',
    /**
     * Game page
     */
    GAME_PAGE: 'game-page',
    /**
     * Game iframe on the game page
     */
    EXPORT_GAME_PAGE: 'export-game-page',
    WIDGET_GAME_PAGE: 'widget-game-page',
    CATEGORY: 'category',
    TAG: 'tag',
    DEVELOPER: 'developer',
    SERIES: 'series',
    CONFIDENTIAL: 'confidential',
    TERMS_OF_USE: 'termsofuse',
    TERMS_OF_USE_MCM: 'mcm-termsofuse',
    LICENSE: 'license',
    PARTNERS_API: 'partners-api',
    CONTACTS: 'contacts',
    PROFILE: 'profile',
    SHOP: 'shop',
    ALL_CATEGORIES: 'all-categories-page',
    ALL_TAGS: 'all-tags-page',
    ALL_SERIES: 'all-series-page',
    TAKEDOWN_NOTICE: 'takedown-notice',
    RANDOM_GAME: 'random-game',
    MY_GAMES: 'my-games',
    DIGITAL_SERVICE_ACT: 'digital-service-act',
    LEADERBOARDS_INFO: 'leaderboards-info',
    ABOUT_US: 'about-us',
    STEAM_GAMES: 'steam-games',
    SEARCH: 'search',
    PLAYGAMA_AUTH_CONSENT: 'playgama-auth-consent',
    KIDS: 'kids',
    KIDS_ERROR: 'kids-error',
    KIDS_NOT_FOUND: 'kids-not-found',
    KIDS_PARENTS: 'kids-parents',
    KIDS_PRIVACY_FOR_KIDS: 'kids-privacy-for-kids',
    KIDS_PRIVACY: 'kids-privacy',
    KIDS_TERMS_OF_USE: 'kids-terms-of-use',
} as const

export const ROUTES_WITH_GAME_PARAM: string[] = [
    ROUTE_NAMES.GAME_PAGE,
    ROUTE_NAMES.EXPORT_GAME_PAGE,
    ROUTE_NAMES.WIDGET_GAME_PAGE,
]

export type ROUTE_NAMES_VALUES = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES]
export type ROUTE_NAMES_GAME_GROUPS =
    | (typeof ROUTE_NAMES)['CATEGORY']
    | (typeof ROUTE_NAMES)['TAG']
    | (typeof ROUTE_NAMES)['SERIES']
    | (typeof ROUTE_NAMES)['DEVELOPER']
